{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "Chào buổi sáng",
        "afternoon": "Chào buổi chiều",
        "evening": "Chào buổi tối"
      },
      "header": {
        "fallbackUser": "Người dùng",
        "facility": "Cơ sở {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} kết quả quan trọng cần xác nhận",
        "message_other": "{{count}} kết quả quan trọng cần xác nhận",
        "reviewNow": "Xem ngay"
      },
      "sections": {
        "overview": "Tổng quan",
        "tasks": "Nhiệm vụ",
        "myPatients": "Bệnh nhân của tôi",
        "recentActivity": "Hoạt động gần đây",
        "quickActions": "Thao tác nhanh"
      },
      "stats": {
        "activeEncounters": "Lượt khám đang hoạt động",
        "pendingOrders": "Y lệnh chờ xử lý",
        "resultsToReview": "Kết quả cần xem xét",
        "criticalAlerts": "Cảnh báo quan trọng"
      },
      "tasks": {
        "unsignedNotes": "Ghi chú chưa ký",
        "criticalResultsPending": "Kết quả quan trọng chờ xử lý",
        "cosignaturesNeeded": "Cần đồng ký",
        "ordersToReview": "Y lệnh cần xem xét",
        "activeMedications": "Thuốc đang dùng",
        "admissionsPending": "Chờ nhập viện",
        "ordersToVerify": "Y lệnh chờ dược sĩ duyệt",
        "controlledSubstanceReviews": "Duyệt thuốc kiểm soát",
        "systemAlerts": "Cảnh báo hệ thống",
        "systemStatus": "Trạng thái hệ thống"
      },
      "systemStatusValue": {
        "healthy": "Bình thường"
      },
      "empty": {
        "noPatients": "Không có bệnh nhân nào được phân công.",
        "noTasks": "Không có nhiệm vụ theo vai trò.",
        "noRecentEncounters": "Không có lượt khám gần đây."
      },
      "quickActions": {
        "findPatient": {
          "label": "Tìm bệnh nhân",
          "description": "Tìm trong hồ sơ"
        },
        "registerPatient": {
          "label": "Đăng ký bệnh nhân",
          "description": "Thêm bệnh nhân mới"
        },
        "viewCensus": {
          "label": "Xem danh sách",
          "description": "Lượt khám đang hoạt động"
        },
        "reports": {
          "label": "Báo cáo",
          "description": "Xem phân tích"
        }
      },
      "viewAll": "Xem tất cả",
      "bedLabel": "Giường {{n}}",
      "admittedLabel": "Nhập viện {{date}}",
      "fallback": {
        "unknownPatient": "Bệnh nhân không xác định",
        "unknownType": "Không xác định"
      },
      "acuity": {
        "1": "Hồi sức",
        "2": "Cấp cứu",
        "3": "Khẩn cấp",
        "4": "Ít khẩn cấp",
        "5": "Không khẩn cấp"
      },
      "encounterType": {
        "emergency": "Cấp cứu",
        "inpatient": "Nội trú",
        "outpatient": "Ngoại trú",
        "observation": "Theo dõi"
      },
      "encounterStatus": {
        "active": "Đang hoạt động",
        "completed": "Đã hoàn thành",
        "discharged": "Đã xuất viện",
        "cancelled": "Đã hủy",
        "pending": "Chờ xử lý"
      }
    },
    "qualityMeasures": {
      "title": "Chỉ số chất lượng",
      "subtitle": "Theo dõi các chỉ số chất lượng lâm sàng và tuân thủ quy định",
      "refresh": "Làm mới",
      "allTypesLabel": "Tất cả loại",
      "allFacilitiesLabel": "Tất cả cơ sở",
      "targetPrefix": "Mục tiêu: {{value}} {{unit}}",
      "updatedPrefix": "Cập nhật: {{value}}",
      "measureType": {
        "process": "Quy trình",
        "outcome": "Kết quả",
        "structure": "Cấu trúc"
      },
      "summary": {
        "totalMeasures": "Tổng số chỉ số",
        "meetingTarget": "Đạt mục tiêu",
        "belowTarget": "Dưới mục tiêu"
      },
      "toasts": {
        "refreshSuccess": "Đã làm mới chỉ số"
      },
      "results": {
        "title": "Kết quả đã ghi nhận",
        "period": "Kỳ",
        "facility": "Cơ sở",
        "denominator": "Mẫu số",
        "numerator": "Tử số",
        "exclusions": "Loại trừ",
        "rate": "Tỷ lệ",
        "source": "Nguồn",
        "calculated": "Ngày tính",
        "empty": "Chưa có kết quả nào được ghi nhận cho chỉ số này trong kỳ này.",
        "loadError": "Không thể tải kết quả đã ghi nhận.",
        "allFacilities": "Tất cả cơ sở",
        "record": "Ghi nhận kết quả"
      },
      "sources": {
        "manual": "Thủ công",
        "sql-template": "Mẫu SQL",
        "import": "Nhập dữ liệu"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "Đã tải xuống báo cáo QRDA",
        "error": "Tải xuống QRDA thất bại"
      },
      "record": {
        "title": "Ghi nhận kết quả chất lượng",
        "titleFor": "Ghi nhận kết quả — {{code}} {{name}}",
        "subtitle": "Kết quả đã ghi xuất hiện trong lịch sử của chỉ số và được đưa vào tệp xuất QRDA Nhóm III. Ghi lại một kỳ sẽ thay thế dòng trước đó.",
        "back": "Về các chỉ số chất lượng",
        "cancel": "Hủy",
        "save": "Ghi nhận kết quả",
        "measureNotFound": "Không tìm thấy chỉ số. Có thể chỉ số đã bị vô hiệu.",
        "fields": {
          "periodStart": "Bắt đầu kỳ",
          "periodEnd": "Kết thúc kỳ",
          "facility": "Cơ sở",
          "allFacilities": "Tất cả cơ sở",
          "denominator": "Mẫu số",
          "numerator": "Tử số",
          "exclusions": "Loại trừ",
          "source": "Nguồn tính toán",
          "completeness": "Mức đầy đủ dữ liệu",
          "completenessHint": "Tỉ lệ hồ sơ đủ điều kiện có dữ liệu đầy đủ, từ 0 đến 1. Bỏ trống nếu không rõ.",
          "notes": "Ghi chú"
        },
        "errors": {
          "periodStartRequired": "Bắt buộc nhập ngày bắt đầu kỳ",
          "periodEndRequired": "Bắt buộc nhập ngày kết thúc kỳ",
          "periodOrder": "Ngày kết thúc kỳ phải cùng hoặc sau ngày bắt đầu",
          "countInvalid": "Nhập số nguyên từ 0 trở lên",
          "numeratorExceeds": "Tử số không được vượt mẫu số",
          "numeratorExceedsNet": "Tử số không được vượt mẫu số trừ các trường hợp loại trừ",
          "sourceRequired": "Bắt buộc chọn nguồn tính toán",
          "completenessRange": "Mức đầy đủ phải từ 0 đến 1"
        },
        "toast": {
          "success": "Đã ghi nhận kết quả",
          "error": "Ghi nhận thất bại"
        }
      }
    },
    "analyticsDashboard": {
      "title": "Bảng phân tích",
      "subtitle": "Chỉ số và xu hướng vận hành bệnh viện",
      "refresh": "Làm mới",
      "changeVsPrevPeriod": "{{sign}}{{value}}% so với kỳ trước",
      "dateRange": {
        "today": "Hôm nay",
        "7d": "7 ngày",
        "30d": "30 ngày",
        "90d": "90 ngày"
      },
      "facility": {
        "all": "Tất cả cơ sở",
        "sgh": "SGH - Bệnh viện Đa khoa Singapore",
        "nuh": "NUH - Bệnh viện Đại học Quốc gia",
        "ttsh": "TTSH - Bệnh viện Tan Tock Seng"
      },
      "department": {
        "all": "Tất cả khoa",
        "er": "Cấp cứu",
        "icu": "Hồi sức tích cực",
        "medsurg": "Nội/Ngoại tổng quát",
        "peds": "Nhi khoa",
        "maternity": "Sản khoa"
      },
      "widget": {
        "census": {
          "title": "Số bệnh nhân hiện tại"
        },
        "bedOccupancy": {
          "title": "Tỷ lệ sử dụng giường"
        },
        "avgLOS": {
          "title": "Thời gian nằm viện trung bình"
        },
        "throughput": {
          "title": "Tổng lượt khám"
        },
        "readmission": {
          "title": "Y lệnh chờ xử lý"
        }
      },
      "unit": {
        "patients": "bệnh nhân",
        "days": "ngày",
        "encounters": "lượt khám",
        "orders": "y lệnh"
      },
      "charts": {
        "admissionsVsDischarges": "Nhập viện so với xuất viện",
        "admissionsByDepartment": "Nhập viện theo khoa",
        "encounterTypes": "Loại lượt khám",
        "censusTrend": "Xu hướng số bệnh nhân",
        "insufficientData": "Không đủ dữ liệu cho biểu đồ",
        "insufficientTrendData": "Không đủ dữ liệu cho biểu đồ xu hướng"
      },
      "series": {
        "admissions": "Nhập viện",
        "discharges": "Xuất viện",
        "census": "Số bệnh nhân"
      },
      "toasts": {
        "refreshSuccess": "Đã làm mới bảng phân tích"
      }
    },
    "reportRunner": {
      "title": "Trình chạy báo cáo",
      "subtitle": "Tạo và xuất các báo cáo lâm sàng, tài chính và vận hành",
      "scheduleButton": "Lên lịch báo cáo",
      "searchPlaceholder": "Tìm kiếm báo cáo...",
      "allCategoriesLabel": "Tất cả báo cáo",
      "category": {
        "clinical": "Lâm sàng",
        "financial": "Tài chính",
        "operational": "Vận hành",
        "quality": "Chất lượng"
      },
      "emptyState": {
        "title": "Chọn một báo cáo để bắt đầu",
        "subtitle": "Chọn từ danh sách báo cáo bên trái"
      },
      "noResults": "Không có báo cáo nào khớp với bộ lọc",
      "parametersHeading": "Tham số",
      "selectOptionPlaceholder": "Chọn...",
      "runButton": "Chạy báo cáo",
      "runningReport": "Đang chạy báo cáo...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "Ngày (giờ địa phương cơ sở)",
        "facilityTimeZone": "Múi giờ cơ sở",
        "encounterDate": "Ngày (UTC)"
      },
      "resultSummary": {
        "rows": "Đang hiển thị {{shown}}/{{total}} dòng",
        "executed": "Đã thực hiện trong {{ms}}ms"
      },
      "toasts": {
        "success": "Báo cáo hoàn tất trong {{executionTimeMs}}ms - {{rowCount}} dòng",
        "failed": "Không thể chạy báo cáo",
        "missingFields": "Vui lòng điền các trường bắt buộc: {{missingFields}}",
        "exporting": "Đang xuất dưới dạng {{format}}... (giữ chỗ)",
        "scheduledPlaceholder": "Thiết lập báo cáo theo lịch (giữ chỗ)"
      }
    }
  }
}
